// sleep 함수
export default (ms = 100) => {
  return new Promise(resolve => setTimeout(resolve, ms))
}
